import { Navbar, Dropdown } from 'flowbite-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LOGOUT } from '../features/user/user_slice';
import { useSelector } from 'react-redux';
    

export default function NavBar() {

    // use state to update the active link in the navbar based on the current path name 
    const [activeLink, setActiveLink] = useState(window.location.pathname);
    let path = window.location.pathname;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.userReducer.user);
    // on click of the navbar links, update the active link
    const handleLinkClick = (link) => () => {
        if (link === path) return;
        path = link;
        navigate(link);
        setActiveLink(link);
        // react-router-dom trigger navigation 
    
        console.log(`${link} : activeLink: ${activeLink}`);
    };

    const handleLogout = () => {
        console.log("logout");
        dispatch( LOGOUT() );
        navigate('/');
    }
    const topNavButtonClass = "select-none rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400";

    return (

        <Navbar
            fluid
            rounded
            fixed="top"
        >
            <Navbar.Brand
            onClick={handleLinkClick('/home')}
            className=' cursor-pointer'>
                <img
                    alt="Flowbite React Logo"
                    className="mr-3 h-6 sm:h-9"
                    src="https://s3-ap-southeast-1.amazonaws.com/rgk-images/17tts_head_maxi_lc.png"
                />
                <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
                     <span className=' font-extrabold'>QUIPPY </span> <span className=' font-extralight text-xs'>by galaxykids</span> 
                </span>
            </Navbar.Brand>
            <div className="flex md:order-2">
                <Dropdown
                    inline
                    label=
                    {
                        <span> {user?.name == null || "none" ? user?.email || "-" : user.name}</span>
                    }
                >
                    <Dropdown.Header>
                        <span className="block text-sm">
                           {user?.role}: {user?.name}
                        </span>
                        <span className="block truncate text-sm font-medium">
                            {user?.email}
                        </span>
                    </Dropdown.Header>
                   
                    <Dropdown.Item>
                        Settings
                    </Dropdown.Item>
                    <Dropdown.Item>
                        Support
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>
                        Sign out
                    </Dropdown.Item>
                </Dropdown>
                <Navbar.Toggle />
            </div>
            <Navbar.Collapse>
                <Navbar.Link className="md:!p-0">
                    <button
                        type="button"
                        onClick={handleLinkClick('/home')}
                        className={topNavButtonClass}
                    >
                        Home
                    </button>
                </Navbar.Link>
                <Navbar.Link className="md:!p-0">
                    <button
                        type="button"
                        onClick={() => {
                            window.open('https://www.dashboard.quippy.co', '_blank', 'noopener,noreferrer');
                        }}
                        className={topNavButtonClass}
                    >
                        Dashboard
                    </button>
                </Navbar.Link>
                {user?.role === 'admin' && (
                    <Navbar.Link active={activeLink === '/admin'} style={{cursor: activeLink !== '/admin' ? "pointer" : "default" }} onClick={handleLinkClick('/admin')} >
                        Admin
                    </Navbar.Link>
                )}
                {/* <Navbar.Link active={activeLink === '/speechlab'} style={{cursor: activeLink !== '/home' ? "pointer" : "default" }} onClick={handleLinkClick('/speechlab')} >
                   FAQ
                </Navbar.Link> */}
                {/* WIKI and Contact Us hidden per request */}
            </Navbar.Collapse>
        </Navbar>

    );
}
